import classNames from 'classnames';

import { EditableTitle } from '@utilities';

import {
  getScreenerPromptDisplayValue,
  SCREENER_PROMPT_TOKEN_REGEX,
  toScreenerPromptTestId,
} from '../../../utilities';

import styles from '../_index.module.scss';

interface RenderTextWithPromptsParams {
  keyPrefix: string;
  missingPromptKeys: string[];
  onPromptChange: (promptKey: string, value: string) => void;
  promptValues: Record<string, string>;
  template: string;
  touchedPromptKeys: Set<string>;
}

export const renderTextWithPrompts = ({
  keyPrefix,
  missingPromptKeys,
  onPromptChange,
  promptValues,
  template,
  touchedPromptKeys,
}: RenderTextWithPromptsParams) => {
  const nodes = [];
  let lastIndex = 0;
  let match;

  SCREENER_PROMPT_TOKEN_REGEX.lastIndex = 0;
  while ((match = SCREENER_PROMPT_TOKEN_REGEX.exec(template)) !== null) {
    const [fullMatch, promptKey] = match;
    const index = match.index;

    if (index > lastIndex) {
      nodes.push(
        <span key={`${keyPrefix}-text-${lastIndex}`}>{template.slice(lastIndex, index)}</span>
      );
    }

    const promptValue = getScreenerPromptDisplayValue({
      promptKey,
      promptValues,
      touchedPromptKeys,
    });

    nodes.push(
      <span
        className={classNames(styles['preview-view-inline-prompt-wrapper'], {
          [styles['preview-view-inline-prompt-error']]: missingPromptKeys.includes(promptKey),
        })}
        data-testid={toScreenerPromptTestId(promptKey)}
        key={`${keyPrefix}-prompt-${promptKey}-${index}`}
      >
        <EditableTitle
          aria-invalid={missingPromptKeys.includes(promptKey)}
          className={styles['preview-view-inline-prompt']}
          onBlur={(value) => onPromptChange(promptKey, value)}
          onChange={(value) => onPromptChange(promptKey, value)}
          value={promptValue}
        />
      </span>
    );

    lastIndex = index + fullMatch.length;
  }

  if (lastIndex < template.length) {
    nodes.push(<span key={`${keyPrefix}-text-${lastIndex}`}>{template.slice(lastIndex)}</span>);
  }

  return nodes;
};
